import React from "react";
import styles from "./LeadMagnetComponent.module.css";

const LeadMagnetComponent = () => {
  return (
    <section className={styles.leadMagnet}>
      <div className={styles.container}>
        <h2 className={styles.title}>Unlock Hidden Efficiencies</h2>
        <p className={styles.description}>
          Most businesses are losing money without realizing it—through outdated systems, manual processes, and wasted tools. 
          This free audit pinpoints where you're overspending, underperforming, and missing out on automation opportunities.
        </p>
        <div className={styles.cta}>
          <a href="/contact" className={`${styles.btn} ${styles.primaryBtn}`}>
            Claim My Free Efficiency Audit
          </a>
        </div>
        <p className={styles.note}>📉 See where you’re leaving money on the table—in under 30 minutes.</p>
        <p className={styles.trust}>
          🔒 Private. No spam. No pressure to buy. Just honest advice.
        </p>
      </div>
    </section>
  );
};

export default LeadMagnetComponent;
